import { required, email } from "vee-validate/dist/rules";
import { extend } from "vee-validate";

extend("required", {
    ...required,
    message: "Dit veld is vereist."
});

extend("email", {
    ...email,
    message: "Er is een geldig e-mailadres vereist."
});